'use es6';

import I18n from 'I18n';
import * as SubmissionTypes from '../constants/submissions/SubmissionTypes';
import { ListingStatus } from '../constants/Listings';
const MAX_INSTALLS_BUCKET = 10000;
const NEW_LISTING_DAYS = 30;

const getValueFactor = (value, factor) => {
  return Math.floor(value / factor) * factor;
};

export const getInstallsBucket = value => {
  if (value < 10) {
    return 0;
  } else if (value < 50) {
    return getValueFactor(value, 10);
  } else if (value < 100) {
    return getValueFactor(value, 50);
  } else if (value < 500) {
    return getValueFactor(value, 100);
  } else if (value < MAX_INSTALLS_BUCKET) {
    return getValueFactor(value, 500);
  }

  return MAX_INSTALLS_BUCKET;
};
export const getIsNewOffering = firstPublishedAt => {
  const diffInDays = I18n.moment().diff(I18n.moment(firstPublishedAt), 'days');
  return diffInDays < NEW_LISTING_DAYS;
};
export const getListingSubmissionType = offering => {
  if (offering && offering.get('publishedListing')) {
    return SubmissionTypes.UPDATE_LISTING;
  }

  return SubmissionTypes.NEW_LISTING;
};
export const getIsListingSubmission = submissionType => {
  return [SubmissionTypes.NEW_LISTING, SubmissionTypes.UPDATE_LISTING].includes(submissionType);
};
export const getListingSubmission = offering => {
  return offering.get('submissions').find(sub => [SubmissionTypes.NEW_LISTING, SubmissionTypes.UPDATE_LISTING].includes(sub.submissionType));
};
export const getIsPublishedOffering = offering => offering && [ListingStatus.CERTIFIED, ListingStatus.LISTED, ListingStatus.PUBLISHED, ListingStatus.PENDING_UNPUBLISH].includes(offering.get('status'));
export const getIsPublishedLocalizedOffering = offering => offering && offering.get('listings') && offering.get('listings').valueSeq().some(localization => getIsPublishedOffering(localization));